import Image from "next/legacy/image";
import { FAIcon, isFASlug } from "./FontAwesome";
import { getZapierBaseUrl } from "lib/route-helpers";
import { iconNames } from "@zapier/design-system";

interface Props {
  iconSlug: string | undefined;
}

export function FieldIcon({ iconSlug }: Props) {
  if (!iconSlug) return null;

  if (iconSlug in iconNames) return null;

  const icon = isFASlug(iconSlug) ? (
    <FAIcon slug={iconSlug} />
  ) : (
    <Image
      alt="icon"
      height={20}
      src={`${getZapierBaseUrl()}/generated/${iconSlug}/32`}
      width={20}
    />
  );

  return (
    <span className="mr-1 flex h-5 w-5 items-center justify-center">
      {icon}
    </span>
  );
}
